const DocumentInspectorTestIdsScope = {
  DOCUMENT_INSPECTOR: 'document-inspector',
};

export const DocumentInspectorTestIds = {
  TABS: `${DocumentInspectorTestIdsScope.DOCUMENT_INSPECTOR}.tabs`,
  COLLAPSE_BUTTON: `${DocumentInspectorTestIdsScope.DOCUMENT_INSPECTOR}.collapse-button`,
  STATUS_CHIP: `${DocumentInspectorTestIdsScope.DOCUMENT_INSPECTOR}.status-chip`,
  COUNT_BADGE: `${DocumentInspectorTestIdsScope.DOCUMENT_INSPECTOR}.count-badge`,
  HELPER_BANNER: `${DocumentInspectorTestIdsScope.DOCUMENT_INSPECTOR}.helper-banner`,
};
